import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { BehaviorSubject, Observable, Subject, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpFunctionsService } from '../http-services/http-functions.service';
import { CommonService } from '../Common-function/common.service';
import { BeatListModel } from 'src/app/models/beat-list-model';

@Injectable({
  providedIn: 'root'
})
export class FavoriteService {
  favBaseUrl:string = 'user-feature/';
  followBaseUrl:string = 'followers/';
  favCount: BehaviorSubject<number> =  new BehaviorSubject(0);
  isChangeCurrentBeat = new Subject();
  constructor(private httpMethodCommon: HttpFunctionsService,
    private commonService: CommonService,
    private ngxSpinner: NgxSpinnerService) { }
  
  /**
   * Add and Remove data from Favorite section
   * @param beatId 
   * @returns 
   */
  addRemoveFavorite(beatId: string, callingType:any) {
    const sendData = {
      "beat_id": beatId
    }
    const endpoint = callingType === 'favorite' ? 'favourite' : 'removefavourite';
    return this.httpMethodCommon.postMethod(this.favBaseUrl + endpoint, sendData);
  }

  /**
   * Add and Remove data from Sound Favorite section
   * @param soundId 
   * @returns 
   */
  addRemoveSoundFavorite(soundId: string, callingType:any) {
    const sendData = {
      "sound_id": soundId
    }
    return this.httpMethodCommon.postMethod('user-feature/'+callingType+'-sound',sendData);
  }


  callingApiAddRemove(beatData:any) {
    let beat_id = beatData._id;
      let callingType = beatData.isFav ? 'favorite' : 'removeFavorite';
      this.addRemoveFavorite(beat_id,callingType).subscribe(res => {
        let messageShow = callingType === 'favorite' ? 'This beat is added into you favorite list' : 'This beat removed into you favorite list';
        this.commonService.showToastSuccess(messageShow);
      }, (error) => {
        this.commonService.showToastError(error);
      });
  }


  callingApiAddRemoveSound(soundData:any) {
    let sound_id = soundData._id;
      let callingType = soundData.isFavorite ? 'favourite' : 'remove-favourite';
      this.addRemoveSoundFavorite(sound_id,callingType).subscribe(res => {
        let messageShow = callingType === 'favourite' ? 'This sound is added into you favorite list' : 'This sound removed into you favorite list';
        this.commonService.showToastSuccess(messageShow);
      }, (error) => {
        this.commonService.showToastError(error);
      });
  }


  /**
   * Get favorite list data (unpaginated — returns every favorited beat, used for
   * counts / summaries where the whole list is needed at once)
   * @returns
   */
  getFavoriteList(): Observable<Array<BeatListModel>> {
    return this.httpMethodCommon.getMethod(this.favBaseUrl+'getFavouritesV3').pipe( map( res => {
      let favList: Array<BeatListModel> = [];
      if (res?.beats && res.beats.length > 0) {
        res.beats.filter((item: BeatListModel) => item.isFav = true);
        favList = res?.beats;
      }
      return favList;
    }),catchError(error => {
      return throwError(error)
    }));
  }

  /**
   * Get favorite list data, one page at a time — for the Favourites page's infinite
   * scroll, backed by getFavouritesV3's page/limit query params.
   * @param page 1-indexed page number
   * @param limit page size
   * @returns
   */
  getFavoriteListPaginated(page: number, limit: number, isShowLoader: boolean = true): Observable<{
    beats: Array<BeatListModel>,
    pagination: { page: number, limit: number, hasMore: boolean, totalCount: number }
  }> {
    return this.httpMethodCommon.getMethodWithParams(this.favBaseUrl + 'getFavouritesV3', { page, limit }, isShowLoader).pipe(
      map(res => {
        const beats: Array<BeatListModel> = res?.beats || [];
        beats.forEach((item: BeatListModel) => item.isFav = true);
        return {
          beats,
          pagination: res?.pagination || { page, limit, hasMore: false, totalCount: beats.length }
        };
      }),
      catchError(error => throwError(error))
    );
  }

  
    /**
   * Get favorite sounds list data
   * @returns 
   */
  getFavoriteSoundList(): Observable<Array<any>> {
    return this.httpMethodCommon.getMethod('user-feature/favourite-sounds').pipe( map( res => {
      let favList: Array<any> = []; 
      if (res?.sounds && res.sounds.length > 0) {
        res.sounds.filter((item: any) => item.isFav = true);
        favList = res?.sounds;
      }
      return favList;
    }),catchError(error => {
      return throwError(error)
    }));
  }

  /**
   * Get Follow Count
   * @param producerId 
   * @returns 
   */
  getCountFollow(producerId: string) {
    const sendData = {
      "producer_id":producerId
    }
    return this.httpMethodCommon.postMethod(this.followBaseUrl+'getFollowerCount',sendData);
  }

  /**
   * un follow producer
   * @param producerId 
   * @returns 
   */
  unFollowProducer(producerId: string) {
    const sendData = {
      "producer_id":producerId
    }
    return this.httpMethodCommon.postMethod(this.followBaseUrl+'unFollow',sendData);
  }

  /**
   * follow the producer
   * @param producerId 
   * @returns 
   */
  followProducer(producerId: string) {
    const sendData = {
      "producer_id":producerId
    }
    return this.httpMethodCommon.postMethod(this.followBaseUrl+'follow',sendData);
  }
  /**
   * check follow the producer
   * @param producerId 
   * @returns 
   */
  checkFollowProducer(producerId: string) {
    const sendData = {
      "producer_id":producerId
    }
    return this.httpMethodCommon.postMethod(this.followBaseUrl+'checkFollower',sendData);
  }
}